import { Toast } from 'vant'
import { get as _get } from 'lodash'
import uap from 'ua-parser-js'
import canvasSize from 'canvas-size';
import domToImage from 'dom-to-image'
import { toPng } from 'html-to-image';
import { domToPng } from 'modern-screenshot';
import { isIos, isAndroid, isWeChat } from 'common/utils/variables'

export function textOverflowEllipsis (str, n) {
  let text = ''
  if (str && n && n > 2) {
    text = String(str)
    const ChineseChars = text.match(/[^0-9a-z.()]/g) || ''
    const nonChineseChars = text.match(/[0-9a-z.()]/g) || ''
    const count = ChineseChars.length + nonChineseChars.length * 0.5
    if (count > n) {
      text = text.substring(0, n - 2) + '...'
    }
  }
  return text
}

export async function imageUrlToBase64(url) {
  if (!url) {
    return ''
  }
  const response = await fetch(url, { mode: 'cors' })
  if (!response.ok) {
    throw new Error(`Failed to fetch image: ${response.status} ${response.statusText}`)
  }
  const blob = await response.blob()

  return await new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}

export async function calcImageMaxScale(element) {
  const userAgent = _get(window, 'navigator.userAgent') || ''
  const ua = userAgent ? uap(userAgent) : ''
  const osVersion = _get(ua, 'os.version') && (typeof Number(_get(ua, 'os.version')) === 'number') ? parseInt(_get(ua, 'os.version')) : null
  const maxScale = isAndroid && (!osVersion || osVersion < 13) ? 2 : 3
  let scale = maxScale
  if (element) {
    const canvasSizeData = await canvasSize.maxArea({
      max: 18000,
      min: 1,
      step: 100
    }).catch(() => {});
    const rect = element.getBoundingClientRect();
    const safetyFactor = isAndroid ? 0.8 : 0.8
    const maxWidth = _get(canvasSizeData, 'width') ? _get(canvasSizeData, 'width') * safetyFactor : 4096 * safetyFactor;
    const maxHeight = _get(canvasSizeData, 'height') ? _get(canvasSizeData, 'height') * safetyFactor : 4096 * safetyFactor;
    scale = Math.min(maxScale, maxWidth / rect.width, maxHeight / rect.height);
    console.log('osVersion: ', osVersion)
    console.log(`canvas: ${canvasSizeData.width}, ${canvasSizeData.height}；rect: ${rect.width}, ${rect.height}；safe: ${maxWidth}, ${maxHeight}；scale: ${scale}`)
  }
  return scale
}

// 多次调用 canvasSize.maxArea 返回值不一致
// 基于源码分析，主要原因是：
// * 实时测试机制：每次调用都是对当前浏览器状态的实时检测
// * 资源释放延迟： WebGL 纹理删除后，GPU 内存不会立即释放
// * 浏览器状态波动：内存压力、其他标签页活动等都会影响测试结果
export async function domToImageToPng(element) {
  if (element) {
    const scale = await calcImageMaxScale(element)
    const rect = element.getBoundingClientRect()
    const width = rect.width * scale
    const height = rect.height * scale
    const config = {
      width,
      height,
      style: {
        transform: `scale(${scale})`,
        transformOrigin: 'top left'
      }
    }
    console.log(`dom-to-image: ${width}, ${height}`)
    return domToImage
      .toPng(element, config)
      .catch(error => {
        console.error('导出图片: ', error)
        Toast('生成图片失败！')
        throw error
      })
  }
  return Promise.resolve('')
}

export async function htmlToImageToPng(element) {
  if (element) {
    const scale = await calcImageMaxScale(element)
    const config = {
      pixelRatio: scale,
      skipFonts: true
    }
    console.log(`html-to-image`)
    return toPng(element, config)
      .catch(error => {
        console.error('导出图片: ', error)
        Toast('生成图片失败！')
        throw error
      })
  }
  return Promise.resolve('')
}

export async function modernScreenshotToPng(element, scaleElement) {
  if (element) {
    // 如果提供了 scaleElement，则基于它来计算 scale；否则使用 element
    const scale = await calcImageMaxScale(scaleElement || element)
    const config = {
      scale,
      features: {
        removeControlCharacter: false
      }
    }
    console.log('modern-screenshot')
    return domToPng(element, config)
      .catch(error => {
        console.error('导出图片: ', error)
        Toast('生成图片失败！')
        throw error
      })
  }
  return Promise.resolve('')
}

export function weixinFontSizeHandler () {
  function setFontSize() {
    WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
    WeixinJSBridge.on('menu:setfont', function() {
      WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
    });
  }

  if (isWeChat) {
    document.body.classList.add('text-size-adjust-100')
    if (typeof WeixinJSBridge === 'object') {
      setFontSize();
    } else {
      document.addEventListener('WeixinJSBridgeReady', setFontSize, false);
    }
  }
}